import {rest} from "msw"
import {boxSizesJson, citiesJson, shopsProfileJson} from "./respanses/profile";
import {
    cancelOrder,
    orderDetailJson,
    orderPageOneJson,
    orderReportPostJson
} from "./respanses/ordersList";
import {
    addAddressBook,
    addressBooksJson,
    deleteAddressBook, deleteAddressBookJson,
    updateAddressBook,
    updateAddressBookJson
} from "./respanses/addressBook";
import {dashboardJson} from "./respanses/dashboard";
import {bulkPdfListJson, orderReportsJson} from "./respanses/fileList";
import {
    addItemsToCart,
    deleteCartItems,
    cartDeleteItemsJson,
    cartItemsJobJson,
    cartItemsJson,
    cartShipmentInfosJson,
    cartShipmentInfosPostJson,
    OrderCanBeCancelJson,
    OrderCancelJson,
    updateCartItems,
    canUseCodJson, shippingDetailsJson, shippingDetailsPostJson
} from "./respanses/order/cart";
import {bulkJson, excelJson} from "./respanses/order";
import {authenticatesJson, tokensJson} from "./respanses/login";


export const handlers = () => {
    console.log('window.location.href', window.location.href)
    const list = [

        rest.get(`*/box-sizes`, (req, res, ctx) => {
            return res(ctx.json(boxSizesJson))
        }),
        rest.get(`*/cities`, (req, res, ctx) => {
            return res(ctx.json(citiesJson))
        }),
        rest.get(`*/shops/profile`, (req, res, ctx) => {
            return res(ctx.json(shopsProfileJson))
        }),
        rest.get(`*/orders?page=1&`, (req, res, ctx) => {
            return res(ctx.json(orderPageOneJson))
        }),
        rest.get(`*/addressbooks`, (req, res, ctx) => {
            return res(ctx.json(addressBooksJson))
        }),
        rest.get(`*/shops/dashboard`, (req, res, ctx) => {
            return res(ctx.json(dashboardJson))
        }),
        rest.post(`*/shops/can-use-cod`, (req, res, ctx) => {
            return res(ctx.json(canUseCodJson))
        }),
        rest.get(`*/orders/bulk/pdf/list`, (req, res, ctx) => {
            return res(ctx.json(bulkPdfListJson))
        }),
        rest.get(`*/orders/reports`, (req, res, ctx) => {
            return res(ctx.json(orderReportsJson))
        }),
        rest.post(`*/cart/items`, (req, res, ctx) => {
            addItemsToCart(req.body, 1)
            return res(ctx.json(cartItemsJson))
        }),
        rest.get(`*/cart/items/job`, (req, res, ctx) => {
            return res(ctx.json(cartItemsJobJson))
        }),
        rest.get(`*/cart/shipment-infos/items/:id/null`, (req, res, ctx) => {
            const {id} = req.params
            return res(ctx.json(shippingDetailsJson(id)))
        }),
        rest.get(`*/cart/shipment-infos/items/:id/*`, (req, res, ctx) => {
            return res(ctx.json(shippingDetailsPostJson))
        }),
        rest.get(`*/cart/items`, (req, res, ctx) => {
            return res(ctx.json(cartItemsJson))
        }),
        rest.patch(`*/orders/cancel`, (req, res, ctx) => {
            const {orderId} = req.body
            cancelOrder(orderId)
            return res(ctx.json(OrderCancelJson))
        }),
        rest.get(`*/cart/shipment-infos`, (req, res, ctx) => {
            return res(ctx.json(cartShipmentInfosJson(shopsProfileJson.payload.cart.itemsCount)))
        }),
        rest.post(`*/cart/shipment-infos`, (req, res, ctx) => {
            deleteCartItems([], true)
            updateCartItems(false, true)
            return res(ctx.json(cartShipmentInfosPostJson))
        }),
        rest.post(`*/orders/reports`, (req, res, ctx) => {
            return res(ctx.json(orderReportPostJson))
        }),
        rest.post(`*/cart/items/excel`, async (req, res, ctx) => {
            await addItemsToCart({}, Object.keys(excelJson.payload.invalidItems).length + Object.keys(excelJson.payload.validItems).length)
            return res(ctx.json(excelJson))
        }),
        rest.post(`*/cart/items/bulk`, (req, res, ctx) => {
            updateCartItems(true)
            return res(ctx.json(bulkJson))
        }),
        rest.patch(`*/cart/items`, (req, res, ctx) => {
            const {ids, all} = req.body
            deleteCartItems(ids, all)
            return res(ctx.json(cartDeleteItemsJson))
        }),

        rest.get(`*/orders/can-be-cancelled/:id`, (req, res, ctx) => {
            return res(ctx.json(OrderCanBeCancelJson))
        }),
        rest.get(`*/orders/:id`, (req, res, ctx) => {
            return res(ctx.json(orderDetailJson))
        }),
        rest.delete(`*/addressbooks/:id`, (req, res, ctx) => {
            const {id} = req.params
            deleteAddressBook(id)
            return res(ctx.json(deleteAddressBookJson));
        }),
        rest.put(`*/addressbooks/:id`, (req, res, ctx) => {
            const {id} = req.params
            updateAddressBook(id, req.body)
            return res(ctx.json(updateAddressBookJson))
        }),
        rest.post(`*/addressbooks`, (req, res, ctx) => {
            addAddressBook(req.body)
            return res(ctx.json(updateAddressBookJson))
        }),
        rest.put(`*/authenticates`, (req, res, ctx) => {

            return res(ctx.json(authenticatesJson))
        })
        , rest.post(`*/tokens`, (req, res, ctx) => {

            return res(ctx.json(tokensJson))
        }),

    ]
    return list
}